import { useContent } from '@/hooks/useContent';
import { Link } from 'react-router-dom';

export default function VisionSection() {
  const { t } = useContent('about');
  const { t: tc } = useContent('common');
  const { t: imgT } = useContent('images');

  return (
    <section className="relative w-full h-[420px] md:h-[520px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          alt="Beautiful modern energy efficient home exterior"
          className="w-full h-full object-cover object-center"
          src={imgT('about_vision')}
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>
      <div className="relative z-10 text-center max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-extrabold text-white leading-tight">{t('vision_title')}</h2>
        <p className="text-white mt-4 text-base leading-relaxed max-w-xl mx-auto">
          {t('vision_desc')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
          <Link
            to="/contact"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-7 py-3.5 rounded-full text-sm transition-colors cursor-pointer"
          >
            {tc('common_request_quote')}
            <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}